import { capitalize } from "lodash";

type DrfErrorValue = string | number | null | undefined | DrfErrorValue[] | { [key: string]: DrfErrorValue };

interface DrfErrorData {
  [key: string]: DrfErrorValue;
}

/** Every message under one field: DRF sends a list, a bare string, or a nested object. */
const messagesOf = (value: DrfErrorValue): string[] => {
  if (Array.isArray(value)) return value.flatMap(messagesOf);
  if (value !== null && typeof value === "object") return Object.values(value).flatMap(messagesOf);
  return value === null || value === undefined ? [] : [String(value)];
};

/**
 * Convert DRF error response to a readable string.
 *
 * @param {DrfErrorData} errorData - The error data from Django Rest Framework
 * @return {string} - A formatted error message
 */
export const formatDrfErrors = (errorData: DrfErrorData): string[] => {
  return Object.keys(errorData).map(
    (field) => `${capitalize(field)}: ${messagesOf(errorData[field]).join(", ")}`
  );
};
